import React from 'react';
import cx from 'classnames';

export type Kind =
  | 'add'
  | 'brand'
  | 'dark'
  | 'default'
  | 'facebook'
  | 'google'
  | 'grey'
  | 'grey-light'
  | 'link'
  | 'mint-outline'
  | 'outline'
  | 'success'
  | 'transparent'
  | 'twitter'
  | 'underlined-link'
  | 'underlined-link-muted'
  | 'whatsapp'
  | 'white'
  | 'white-orange'
  | 'white-purple'
  | 'orange-outline'
  | 'purple';

interface Props {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  kind?: Kind;
  size?: 'xs' | 'sm' | 'lg' | 'xl';
  type?: 'button' | 'submit';
  title?: string;
  className?: string;
  noWrap?: boolean;
  isBlock?: boolean;
  isBlockMobile?: boolean;
  isActive?: boolean;
  isUppercase?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  iconBefore?: boolean;
}

const Button: React.FC<Props> = ({
  size,
  kind,
  type = 'button',
  title,
  noWrap,
  isBlock,
  isBlockMobile,
  isActive,
  isDisabled,
  isUppercase,
  className,
  children,
  onClick,
  isLoading,
  icon,
  iconBefore,
  ...rest
}) => {
  const btnClass = cx(
    'btn',
    kind ? `btn-${kind}` : '',
    size ? `btn-${size}` : '',
    {
      'btn-wrap': !noWrap,
      'btn-block': isBlock,
      'btn-block-mobile': isBlockMobile,
      active: isActive,
      uppercase: isUppercase,
      'btn-loading': isLoading,
    },
    className,
  );

  const showIcon = Boolean(icon);

  return (
    <button
      onClick={!isDisabled ? onClick : undefined}
      className={btnClass}
      type={type}
      title={title}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {showIcon && iconBefore && icon}
      {showIcon && iconBefore && ' '}
      {children}
      {showIcon && !iconBefore && ' '}
      {showIcon && !iconBefore && icon}
    </button>
  );
};

export { Button };
